import React, { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import AssistantSuggestions from './AssistantSuggestions';
import AssistantInsights from './AssistantInsights';
import ConversationHistory from './ConversationHistory';
import * as S from './MainAssistantPage.styles';

interface MainAssistantPageProps {
  onNewConversation: () => void;
  onInsightClick: (insightId: string) => void;
  onPromptClick: (prompt: string) => void;
  onReviewPublish?: (insightId: string) => void;
  onEditInsight?: (insightId: string) => void;
}

const MainAssistantPage: React.FC<MainAssistantPageProps> = observer(
  ({ onNewConversation, onInsightClick, onPromptClick, onReviewPublish, onEditInsight }) => {
    const scrollableWrapperRef = useRef<HTMLDivElement>(null);

    return (
      <S.MainPageContainer>
        <S.ScrollableContentWrapper ref={scrollableWrapperRef} data-scrollable-content>
          <S.ContentSection>
            <S.SuggestionsWrapper>
              <AssistantSuggestions onNewConversation={onNewConversation} onPromptClick={onPromptClick} />
            </S.SuggestionsWrapper>
            <AssistantInsights
              onInsightClick={onInsightClick}
              onReviewPublish={onReviewPublish}
              onEditInsight={onEditInsight}
              onNewConversation={onNewConversation}
              onPromptClick={onPromptClick}
            />
          </S.ContentSection>
        </S.ScrollableContentWrapper>
        <S.RightPanel>
          <ConversationHistory />
        </S.RightPanel>
      </S.MainPageContainer>
    );
  },
);

MainAssistantPage.displayName = 'MainAssistantPage';

export default MainAssistantPage;
